import { render, staticRenderFns } from "./CommonTips.vue?vue&type=template&id=35e9ba73&"
import script from "./CommonTips.vue?vue&type=script&lang=js&"
export * from "./CommonTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports